'use client'

import Link from 'next/link'
import '@/app/public.css'

const sections = [
  {
    title: 'Use of the service',
    body:
      'BPAL provides access to digital financial features subject to eligibility, verification, and regional availability. You agree to use the platform lawfully and not to misuse onboarding, payment, or referral flows.',
  },
  {
    title: 'Accounts and security',
    body:
      'You are responsible for maintaining accurate account information, protecting your credentials, and notifying us of unauthorized access. We may suspend or limit access where required for security, compliance, or abuse prevention.',
  },
  {
    title: 'Referrals and invitations',
    body:
      'Referral and invitation access can be restricted, revoked, or limited at any time. Invalid, expired, self-issued, abusive, or fraudulent referral activity may result in denied registration or account restrictions.',
  },
  {
    title: 'Updates',
    body:
      'We may update these terms as the product evolves. Continued use of the platform after changes take effect constitutes acceptance of the revised terms.',
  },
]

export default function TermsPage() {
  return (
    <main style={{ minHeight: '100vh', paddingTop: '80px', paddingBottom: '40px' }}>
      <div className="container" style={{ maxWidth: '800px' }}>
        <div style={{ marginBottom: '40px', display: 'flex', alignItems: 'start', justifyContent: 'space-between', gap: '24px', flexWrap: 'wrap' }}>
          <div>
            <p style={{ fontSize: '10px', fontWeight: '500', letterSpacing: '0.15em', textTransform: 'uppercase', color: 'var(--text-muted)', marginBottom: '12px' }}>
              BPAL Legal
            </p>
            <h1 style={{ fontSize: 'clamp(32px, 5vw, 48px)', fontWeight: '700', letterSpacing: '-0.02em', color: 'var(--text)', marginTop: '12px' }}>
              Terms of Service
            </h1>
          </div>
          <Link href="/" className="btn-secondary" style={{ marginTop: '12px' }}>
            Back home
          </Link>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          {sections.map((section) => (
            <section key={section.title} className="definition-block">
              <h2 style={{ fontSize: '18px', fontWeight: '600', color: 'var(--text)', marginBottom: '12px' }}>{section.title}</h2>
              <p style={{ fontSize: '15px', color: 'var(--text-muted)', lineHeight: '1.7' }}>{section.body}</p>
            </section>
          ))}
        </div>
      </div>
    </main>
  )
}
